<script setup lang="ts">
/**
 * The PLAY switches chip (job #496): a small floating chip, PLAY copies only,
 * opening a panel that sets every test switch in `play/switches.ts` on this device.
 * Each switch is read when its screen opens, so a change shows the next time Script opens.
 */
import { ref } from 'vue'
import { SWITCHES, readSwitches, writeSwitch } from '../play/switches'

const open = ref(false)
const values = ref<Record<string, string>>(readSwitches())
const set = (param: string, value: string) => {
  writeSwitch(param, value)
  values.value = readSwitches()
}
</script>

<template>
  <div class="play-switches">
    <button class="chip" type="button" :class="{ on: Object.keys(values).length }" @click="open = !open">⚙ PLAY</button>
    <div v-if="open" class="panel" role="dialog" aria-label="PLAY switches">
      <div v-for="s in SWITCHES" :key="s.param" class="row">
        <span class="label">{{ s.label }}</span>
        <span class="opts">
          <button v-for="o in s.options" :key="o.value" type="button" :class="{ sel: (values[s.param] ?? '') === o.value }" @click="set(s.param, o.value)">{{ o.label }}</button>
        </span>
      </div>
      <p class="note">This device only. Shows next time Script opens.</p>
      <button class="close" type="button" @click="open = false">Done</button>
    </div>
  </div>
</template>

<style scoped>
.play-switches { position: fixed; z-index: 2147483000; left: max(8px, env(safe-area-inset-left, 0px)); bottom: calc(76px + var(--shell-inset-bottom)); font: 13px/1.3 system-ui, sans-serif; }
.chip { border: 0; border-radius: 999px; padding: 5px 10px; background: rgba(40, 40, 40, 0.55); color: #fff; font: inherit; opacity: 0.7; }
.chip.on { background: #c2410c; opacity: 0.9; }
.panel { position: absolute; left: 0; bottom: 36px; width: min(300px, calc(100vw - 16px)); background: #fff; color: #222; border-radius: 12px; padding: 10px 12px; box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25); }
.row { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin: 6px 0; }
.opts { display: flex; gap: 4px; }
.opts button { border: 1px solid #ccc; background: #f5f5f5; border-radius: 6px; padding: 4px 8px; font: inherit; color: #222; }
.opts button.sel { background: #222; color: #fff; border-color: #222; }
.note { margin: 8px 0 6px; color: #666; font-size: 12px; }
.close { width: 100%; border: 0; border-radius: 8px; padding: 6px; background: #eee; font: inherit; }
</style>
